import { dateFormat } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const examine = {
  paper: {
    name: 'paper',
    componentTypes: ['navigate', 'check', 'tables', 'stepForm', 'drawerTable'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'examine/addTraining',
    editFun: 'examine/editSafetyUseAccount',
    getListFun: 'examine/editTraining',
    deleteFun: 'examine/deleteTraining',
    detailPage: [
      {
        buttonName: '新增',
        name: 'training',
        type: 'stepForm',
        theme: 'training',
        step: 'trainingInfo',
        label: '新增培训教育任务'
      },
      {
        buttonName: '编辑',
        name: 'training',
        type: 'stepForm',
        theme: 'training',
        step: 'trainingInfo',
        label: '新增培训教育任务',
        checkType: 'checkByUid',
        checkFun: 'training/getTrainingInfo'
      }
    ],
    headButtons: setCheckButtons(['新增' /* ,'导入培训计划' */]),
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      trainingType: '',
      trainingMethods: '',
      examineType: '',
      isDone: '',
      query: ''
    },
    selectData: [
      {
        key: 'orgUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        clearable: false
      },
      {
        key: 'trainingType',
        label: '培训类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trainingType
        }
      },
      {
        key: 'examineType',
        label: '考核方式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.examineType
        }
      },
      {
        key: 'isDone',
        label: '是否执行',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isFalse
        }
      },
      {
        key: 'trainingMethods',
        label: '培训方式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trainingMethods
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '培训编号/培训名称'
      }
    ],
    rowData: (params) => {
      return params.state.training.trainingList.result
    },
    rowTotal: (params) => {
      return params.state.training.trainingList.totalSize
    },
    columns: [
      { prop: 'trainingNo', label: '培训编号' },
      { prop: 'trainingName', label: '培训名称' },
      { prop: 'trainingType', label: '培训类型' },
      { prop: 'trainingTime', label: '培训时间' },
      { prop: 'trainingPlace', label: '培训地点' },
      { prop: 'trainingDuration', label: '培训时长' },
      { prop: 'trainingPerson', label: '培训人' },
      { prop: 'trainingMethods', label: '培训方式' },
      { prop: 'examineType', label: '考核方式' },
      { prop: 'isDone', label: '是否执行' },
      {
        label: '操作',
        buttons: setTableButtons(['查看', '编辑', '删除', '签到', '二维码'])
      }
    ],
    hasPagination: true,
    addArray: true,
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      trainingType: '进场教育',
      trainingNo: (params) => {
        const onboarding = params.state.training.trainingList.totalSize.filter(
          (item) => {
            return item.trainingType === '进场教育'
          }
        )
        return (
          'JCJY' +
          (onboarding.length + 1 < 10
            ? '0' + (onboarding.length + 1)
            : onboarding.length + 1)
        )
      },
      trainingName:
        new Date().getFullYear() +
        '年' +
        (new Date().getMonth() + 1) +
        '月进场教育培训',
      trainingTime: dateFormat(new Date()),
      trainingPlace: '',
      trainingDuration: '',
      trainingPerson: '',
      trainingMethods: '现场集中培训',
      examineType: '在线考核',
      paperUid: '',
      answerRule: '随答随判',
      trainingBrief: '',
      trainingMaterials: [],
      shouldArrivePeopleNum: '',
      shouldArrivePeople: []
    },
    formRules: {
      trainingType: [
        { required: true, message: '请选择培训类型', trigger: 'blur' }
      ],
      trainingNo: [
        { required: true, message: '请输入培训编号', trigger: 'blur' }
      ],
      trainingName: [
        { required: true, message: '请输入培训名称', trigger: 'blur' }
      ],
      trainingTime: [
        { required: true, message: '请选择培训时间', trigger: 'blur' }
      ],
      trainingPlace: [
        { required: true, message: '请输入培训地点', trigger: 'blur' }
      ],
      trainingDuration: [
        { required: true, message: '请输入培训时长', trigger: 'blur' }
      ],
      trainingPerson: [
        { required: true, message: '请输入培训人', trigger: 'blur' }
      ],
      trainingMethods: [
        { required: true, message: '请选择培训方式', trigger: 'blur' }
      ],
      examineType: [
        { required: true, message: '请选择考核方式', trigger: 'blur' }
      ],
      paperUid: [
        {
          required: function (value, item) {
            return item.examineType !== '不予考核'
          },
          message: '请输入试卷uid',
          trigger: 'blur'
        }
      ],
      answerRule: [
        { required: true, message: '请输入答题规则', trigger: 'blur' }
      ],
      trainingBrief: [
        { required: true, message: '请输入培训简介', trigger: 'blur' }
      ],
      trainingMaterials: [
        {
          required: function (value, item) {
            return item.trainingMethods === '个人自主学习'
          },
          message: '请输入培训材料',
          trigger: 'blur'
        }
      ],
      shouldArrivePeopleNum: [
        { required: true, message: '请输入应到人数', trigger: 'blur' }
      ],
      shouldArrivePeople: [
        { required: true, message: '请输入应到人员名单', trigger: 'blur' }
      ]
    },
    formData: {
      card: '培训教育任务信息',
      manualUpload: true,
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'trainingType',
          label: '培训类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.trainingType
          }
        },
        { key: 'trainingNo', label: '培训编号', type: 'input' },
        { key: 'trainingName', label: '培训名称', type: 'input' },
        {
          key: 'trainingTime',
          label: '培训时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss'
        },
        { key: 'trainingPlace', label: '培训地点', type: 'input' },
        {
          key: 'trainingDuration',
          label: '培训时长',
          type: 'input',
          inputButton: '分钟'
        },
        {
          key: 'trainingPerson',
          label: '培训人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true,
          placeholder: '请输入培训讲师姓名或选择系统内管理人员'
        },
        {
          key: 'trainingMethods',
          label: '培训方式',
          type: 'select',
          options: (params) => {
            return params.dictionarys.trainingMethods
          }
        },
        {
          key: 'examineType',
          label: '考核方式',
          type: 'select',
          options: (params) => {
            return params.dictionarys.examineType
          }
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.examineType !== '不予考核'
              ? 'paperUid'
              : null
          },
          label: '试卷uid',
          type: 'input',
          check: '选择考核试卷',
          readonly: true
        },
        {
          key: 'answerRule',
          label: '答题规则',
          type: 'select',
          options: (params) => {
            return params.dictionarys.answerRule
          }
        },
        {
          key: 'trainingBrief',
          label: '培训简述',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 3, maxRows: 6 }
        },
        {
          key: 'trainingMaterials',
          label: '培训资料',
          type: 'input',
          check: '选择培训资料',
          readonly: true
        },
        {
          key: 'shouldArrivePeopleNum',
          label: '应到人数',
          type: 'input',
          number: true,
          readonly: true
        },
        {
          key: 'shouldArrivePeople',
          label: '应到人员',
          type: 'input',
          check: '选择参会人员'
        }
      ]
    }
  }
}

export default examine
